import { render, staticRenderFns } from "./confirmatory.vue?vue&type=template&id=e530a75a&scoped=true&lang=pug&"
import script from "./confirmatory.vue?vue&type=script&lang=js&"
export * from "./confirmatory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e530a75a",
  null
  
)

export default component.exports